<template>
  <div>
    <div class="cell-editing-input-wrapper"
         :class="{'input-focused': focused}" v-click-outside="onBlur">
      <input v-if="type === 'number'"
             ref='input'
             class="input-inline-editing"
             v-model="currentValue"
             @focus="onFocus"
             @keyup.enter="onOkClick"
             @keyup.esc="onCancelClick"
             type="number"
             :min="min"
      />
      <input v-else
             ref='input'
             class="input-inline-editing"
             v-model="currentValue"
             @focus="onFocus"
             @keyup.enter="onOkClick"
             @keyup.esc="onCancelClick"
      />
      <b-button-group class="cell-editing-buttons">
        <b-button variant="danger" size="sm" @click="onCancelClick">
          <font-awesome-icon icon="times"/>
        </b-button>
        <b-button variant="primary" size="sm" @click="onOkClick" :disabled="isInvalidNumberValue()">
          <font-awesome-icon icon="save"/>
        </b-button>
      </b-button-group>
    </div>
    <div v-if="isInvalidNumberValue()" class="invalid-feedback">
      {{ $t('Value must be {val} or more', {val: min}) }}
    </div>
  </div>
</template>

<script>
  import ClickOutside from 'vue-click-outside'

  export default {
    name: "CellEditingInput",
    props: {
      value: [String, Number],
      type: {
        type: String,
        default: 'text'
      },
      min: {
        type: [String, Number],
        default: 0
      },
    },
    data: () => ({
      focused: false,
      currentValue: null
    }),
    watch: {
      value: {
        immediate: true,
        handler() {
          this.currentValue = this.value;
        }
      }
    },
    methods: {
      onFocus() {
        this.focused = true;
      },
      onBlur() {
        this.focused = false;
      },
      onCancelClick($event) {
        this.focused = false;
        this.currentValue = this.value;
        this.$emit('cancel', $event)
      },
      onOkClick() {
        if (this.isInvalidNumberValue()) {
          return null
        }
        this.focused = false;
        this.$emit('ok', this.currentValue)
      },
      isInvalidNumberValue() {
        return this.type === 'number' && !!this.currentValue && this.currentValue < this.min
      }
    },

    // do not forget this section
    directives: {
      ClickOutside
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../core/scss/variables";
  @import "./../../scss/index";

  .invalid-feedback {
    display: block;
    height: 12px;
  }

  .cell-editing-input-wrapper {
    position: relative;

    input {
      border-radius: $border-radius-sm;
      border: 1px solid $gray-300;
      outline: 0;
      width: 100%;

      &:focus {
        border-color: $primary;
      }
    }

    .cell-editing-buttons {
      position: absolute;
      display: none;
      top: 100%;
      left: 50%;
      transform: translateX(-50%);
      z-index: 10;
      background-color: white;
      padding: 3px;
      border: 1px solid $gray-300;

      > .btn {
        padding-top: 2px;
        padding-bottom: 2px;
      }
    }

    &.input-focused {

      input {
        border-color: $primary;
      }

      .cell-editing-buttons {
        //width: 100%;
        //box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.1);
        display: flex;
        border: 1px solid $primary;
        border-top: none;
        margin-top: -1px;
        margin-right: -1px;
        border-bottom-left-radius: $border-radius-sm;
        border-bottom-right-radius: $border-radius-sm;
      }
    }
  }
</style>
